export default `float de(vec3 p){
    float radius = 1.;
    const float phi = 1.61803398875;  
    const vec3 n = normalize(vec3(phi,1.0,0.0));

    p = abs(p / radius);
    float a = dot(p, n.xyz);
    float b = dot(p, n.zxy);
    float c = dot(p, n.yzx);
    return (max(max(a,b),c)-n.x) * radius;
  }`